var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenConsultScrapEmptyButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66732 1.66602H16.334C16.7942 1.66602 17.1673 2.03912 17.1673 2.49935V18.4521C17.1673 18.6822 16.9807 18.8688 16.7507 18.8688C16.6724 18.8688 16.5957 18.8467 16.5293 18.8051L10.5007 15.0254L4.47198 18.8051C4.27701 18.9273 4.01987 18.8684 3.89763 18.6734C3.85604 18.6071 3.83398 18.5304 3.83398 18.4521V2.49935C3.83398 2.03912 4.20708 1.66602 4.66732 1.66602ZM15.5007 3.33268H5.50065V16.193L10.5007 13.0583L15.5007 16.193V3.33268Z",
    fill: "#12C0B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenConsultScrapEmptyButton);
export default __webpack_public_path__ + "static/media/open-consult-scrap-empty-button.ecc3332c7ef1b141dfae9802977eebc0.svg";
export { ForwardRef as ReactComponent };